import { useEffect, useState } from "react";
import { api } from "./api";

// Mode Stripe courant (stripe_test | stripe_live) — lecture publique, cache module-level.
let cache = null;

export function useStripeMode() {
  const [mode, setMode] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/payments/config").then((r) => { cache = r.data?.mode || null; setMode(cache); }).catch(() => setMode(null));
  }, []);
  return mode; // null tant qu'inconnu — ne rien afficher de spécifique
}
